import React from "react";

const Navbar = (props) => {
  const userData = props.userJson;
  const img_url =
    userData.picture_url === null
      ? "https://fixapi.dinapart.ir/FileStorage/Other/no-avatar.jpg"
      : userData.picture_url;
  return (
    <React.Fragment>
      <nav className="p-2 bg-light container-fluid">
        <div className="row m-0">
          <div className="col-auto">
            <img src={img_url} className="img-circle avatar" alt="user"></img>
          </div>
          {/* {(userData.store_complete === true) ?  */}
          <div className="col-auto align-self-center">
            <p className="text-right wp-text wp-text-bold mb-0">
              موجودی کیف پول
            </p>
            <p className="wp-price mb-0">
              <span className="wp-text-small">هدیه‌های نقدی:</span>{" "}
              <span className="dina-fc-blue">
                {props.budget.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                ریال
              </span>
            </p>
            <p className="wp-price mb-0">
              <span className="wp-text-small">هدایای دیناکد:</span>{" "}
              <span className="dina-fc-blue">
                {props.budgetGift
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                ریال
              </span>
            </p>
          </div>
          <div className="col align-self-center">
            <button
              onClick={() => props.toggleSettlment()}
              className="btn btn-sm dina-btn-orange text-white rounded-pill d-flex float-left"
            >
              درخواست تسویه
            </button>
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
